import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Box,
  useMediaQuery,
  useTheme,
  Hidden,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Logo = styled.img`
  height: 40px;
  margin-right: 16px;
`;

const NavButton = styled(Button)`
  color: white;
  margin: 0 8px;
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { user, logout } = useAuth();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Logo src="/logo1.png" alt="Logo Contrato Seguro" style={{ height: 40, marginRight: 16 }} />
        <Typography variant="h6" component={RouterLink} to="/" sx={{ flexGrow: 1, color: 'inherit', textDecoration: 'none', cursor: 'pointer' }}>
          Contrato Seguro
        </Typography>

        {!user ? (
          <>
            {isMobile ? (
              <>
                <IconButton
                  size="large"
                  edge="end"
                  color="inherit"
                  aria-label="menu"
                  onClick={handleMenu}
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem component={RouterLink} to="/login" onClick={handleClose}>
                    Login Usuário
                  </MenuItem>
                  <MenuItem component={RouterLink} to="/login/provider" onClick={handleClose}>
                    Login Prestador
                  </MenuItem>
                  <MenuItem component={RouterLink} to="/register" onClick={handleClose}>
                    Cadastrar
                  </MenuItem>
                  <MenuItem component={RouterLink} to="/register/professional" onClick={handleClose}>
                    Cadastro Profissional
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <Box>
                <NavButton component={RouterLink} to="/login">
                  Login Usuário
                </NavButton>
                <NavButton component={RouterLink} to="/login/provider">
                  Login Prestador
                </NavButton>
                <NavButton component={RouterLink} to="/register">
                  Cadastrar
                </NavButton>
              </Box>
            )}

            {!isMobile && (
              <div style={{ marginLeft: 'auto' }}>
                <a href="/register/professional" style={{
                  background: '#2196f3',
                  color: 'white',
                  padding: '10px 18px',
                  borderRadius: 8,
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  boxShadow: '0 2px 8px #2196f344',
                  marginLeft: 16
                }}>
                  É um profissional? Cadastre-se aqui
                </a>
              </div>
            )}
          </>
        ) : (
          <Box>
            {user.role === 'provider' && (
              <>
                <NavButton component={RouterLink} to="/plans">
                  Planos
                </NavButton>
                <NavButton component={RouterLink} to="/provider/dashboard">
                  Meu Painel
                </NavButton>
              </>
            )}
            <NavButton component={RouterLink} to="/profile">
              Meu Perfil
            </NavButton>
            <NavButton onClick={() => logout()}>
              Sair
            </NavButton>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar; 